/*
  KP: product badges on the main photo. On product pages the badges the theme prints
  above the title ("Buy 1 Get 1 Half Price", "New", sale badges...) are shown instead in
  the top left corner of the main photo, a little smaller and with slightly rounded
  corners. They show on the FIRST photo only: swipe (phones) or click (larger screens) to
  another photo and they step aside; come back to the first and they return.

  The theme's own badges are not moved (the theme re-draws that part of the page when the
  variant changes): a copy of them is placed on the photo and kept the same as the
  original, and the original is hidden. There are two photo galleries in the page (one
  for phones, one for larger screens; only one shows at a time), so each gets a copy.
  The copy cannot be clicked, so tapping the photo still opens it as before.

  The theme also throws the phone gallery away and draws a new one when the variant
  changes, which takes the copy with it. So the whole product is watched, and the copy is
  put back whenever it has gone missing.

  The size, corners and position are in the style rules at the bottom of this file.
  Loaded by snippets/theme-globals.liquid. Delete that line to put the badges back above
  the title.
*/
(function () {
  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  // Run something once, a moment from now: at the next screen redraw, or after a tenth of
  // a second if no redraw comes (a tab in the background does not redraw).
  function later(fn) {
    var done = false;
    var run = function () {
      if (done) return;
      done = true;
      fn();
    };

    window.requestAnimationFrame(run);
    window.setTimeout(run, 100);
  }

  function copyIn(box) {
    for (var i = 0; i < box.children.length; i++) {
      if (box.children[i].classList.contains('kp-photo-badges')) return box.children[i];
    }
    return null;
  }

  function shown(list) {
    return Array.prototype.filter.call(list, function (node) {
      return node.offsetWidth > 0;
    });
  }

  // Is the first photo the one on screen in this gallery?
  function onFirstPhoto(box) {
    var slider = box.querySelector('.scroll-slider__slider');

    // Phones: a row of photos swiped sideways. First photo = not yet swiped past its middle.
    if (slider && slider.scrollWidth > slider.clientWidth + 4) {
      var slides = shown(slider.children);
      if (!slides.length) return true;
      return slider.scrollLeft + slider.offsetLeft < slides[0].offsetLeft + slides[0].offsetWidth / 2;
    }

    // Larger screens: one photo showing at a time, chosen with the small photos beside it.
    // "First" is the photo of the first small photo on offer (a variant can have its own set).
    var items = box.querySelectorAll('.product__media-item');
    var current = -1;
    each(items, function (item, n) {
      if (current < 0 && item.offsetWidth > 0) current = n;
    });
    if (current < 0) return true;

    var first = 0;
    var thumbs = shown(box.querySelectorAll('[data-thumbnail-index]'));
    if (thumbs.length) first = parseInt(thumbs[0].getAttribute('data-thumbnail-index'), 10) || 0;

    return current === first;
  }

  function start(product) {
    if (product.kpPhotoBadges) return;
    if (!product.querySelector('.product-blocks') || !product.querySelector('.product__media-container')) return;
    product.kpPhotoBadges = true;

    var waiting = false;
    var again = function () {
      if (waiting) return;
      waiting = true;
      later(function () {
        waiting = false;
        sync();
      });
    };

    // Only writes to the page when something is actually missing or different, so it is
    // safe to run after every change (its own changes do not set it off again).
    function sync() {
      var source = product.querySelector('.product-blocks .product__block--product-header .product-badges');
      var html = source ? source.innerHTML.trim() : '';
      var boxes = product.querySelectorAll('.product__media-container');

      each(boxes, function (box) {
        var copy = copyIn(box);

        if (!html) {
          if (copy) box.removeChild(copy);
          return;
        }

        if (!copy) {
          copy = document.createElement('div');
          copy.className = 'kp-photo-badges product-badges';
          copy.setAttribute('aria-hidden', 'true');
          box.appendChild(copy);
        }

        if (copy.kpHtml !== html) {
          copy.innerHTML = html;
          copy.kpHtml = html;
        }

        // Follow the swiping of this gallery's row of photos (a new row after a re-draw).
        var slider = box.querySelector('.scroll-slider__slider');
        if (slider && !slider.kpBadgesBound) {
          slider.kpBadgesBound = true;
          slider.addEventListener('scroll', again, { passive: true });
        }

        var hide = !onFirstPhoto(box);
        if (copy.hidden !== hide) copy.hidden = hide;
      });

      // The style rules hide the theme's own badges while this mark is on.
      var on = !!html && boxes.length > 0;
      if (product.classList.contains('kp-photo-badges-on') !== on) product.classList.toggle('kp-photo-badges-on', on);
    }

    // The title area (badges included) and the phone gallery are both re-drawn by the
    // theme after a variant change; on larger screens a photo is shown or hidden by a
    // change of its class when a small photo is clicked.
    if (window.MutationObserver) {
      new MutationObserver(again).observe(product, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('resize', again);
    sync();
  }

  function initAll() {
    each(document.querySelectorAll('.product'), start);
  }

  var style = document.createElement('style');
  style.textContent = [
    '.product.kp-photo-badges-on .product__media-container{position:relative}',
    '.kp-photo-badges{position:absolute;top:10px;left:10px;z-index:2;display:flex;flex-wrap:wrap;gap:6px;max-width:calc(100% - 20px);margin:0;pointer-events:none}',
    '.kp-photo-badges[hidden]{display:none}',
    '.kp-photo-badges .product-badge{margin:0}',
    '.kp-photo-badges .product-badge__inner{padding:4px 7px;border-radius:5px;font-size:10px;line-height:1.2}',
    '.product.kp-photo-badges-on .product-blocks .product__block--product-header .product-badges{display:none}'
  ].join('');
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
